<div class="flex-column h-100 bg-white">
  <div class="configuration-wizard-header flex-column">
    <h5
      class="odx-title-5"
      i18n="@@gasWarningCenterConfiguration.selectGasWarningCenter.terminalBlocks.header"
      data-testid="gasWarningCenterConfiguration.selectGasWarningCenter.terminalBlocks.header"
    >
      Klemmblöcke auswählen
    </h5>

    <app-filter-product (searchEvent)="search($event)"></app-filter-product>

    <odx-inline-message i18n="@@gasWarningCenterConfiguration.selectGasWarningCenter.terminalBlocks.infoMessage">
      Anhand der gewählten Module wurde bereits eine passende Vorauswahl getroffen, die jedoch noch angepasst werden kann.
    </odx-inline-message>
  </div>

  <odx-content-box class="flex-column flex-scroll" odxLayout="flex">
    @if (filteredTerminalBlocks(); as terminalBlocks) {
      @if (terminalBlocks.length > 0) {
        <div odxLayout="grid 3@desktop 6@tablet 12@phone" class="w-100 mb-36">
          @for (terminalBlock of terminalBlocks; track terminalBlock.id) {
            <app-product-card-with-quantity
              class="overflow-hidden"
              [productData]="terminalBlock"
              selectionMode="multi"
              [showCosts]="project().showCostFlag"
              [quantity]="getSelectedQuantity(terminalBlock)"
              [preselectedQuantity]="getPreselectedQuantity(terminalBlock)"
              (quantityChanged$)="updateSelectedTerminalBlocks($event, terminalBlock)"
            >
              @if (terminalBlock.id) {
                <div class="feature">
                  <p class="p-label odx-text--small" i18n="@@global.partNumber">Sachnummer</p>
                  <p class="odx-text--small">{{ terminalBlock.id }}</p>
                </div>
              }
            </app-product-card-with-quantity>
          }
        </div>
      } @else {
        <app-refresh-products-hint dataType="Klemmblöcke" i18n-dataType="@@global.terminalBlocks"></app-refresh-products-hint>
      }
    }
  </odx-content-box>
</div>
